const isEnoughAddData = (richContentToDisplay, addInfo) => {
	if (!addInfo || richContentToDisplay?.length === 0) {
		return false;
	}

	const isNotEmpty = (obj) => {
		if (Array.isArray(obj)) {
			return obj.length > 0;
		}
		if (obj) {
			return Object.keys(obj).length > 0;
		}
		return false;
	};

	const CONTENT_TYPES = {
		HOURS: [
			'hours-sales',
			'hours-service',
			'hours-parts',
			'hours-commercial'
		],
		LOCATION: ['address'],
		CONTACT: [
			'phone-sales',
			'phone-service',
			'phone-parts',
			'phone-commercial',
			'email'
		]
	};
	const { hours = {}, mapLink, dealerInfo = {}, phoneNumbers = [] } = addInfo;

	const hasRequestedContent = (items, targetKeys) =>
		items.some((item) => targetKeys.includes(item));

	const requestedHours = richContentToDisplay.filter((item) =>
		CONTENT_TYPES.HOURS.includes(item)
	);
	if (requestedHours.length > 0) {
		// Check if any requested hours exist in addInfo
		// Map 'hours-service' -> 'SERVICE', 'hours-sales' -> 'SALES', etc.
		const hasAnyRequestedHours = requestedHours.some((hourType) => {
			const deptName = hourType.replace('hours-', '').toUpperCase();
			return isNotEmpty(hours[deptName]);
		});
		if (hasAnyRequestedHours) {
			return true;
		}
	}

	if (hasRequestedContent(richContentToDisplay, CONTENT_TYPES.LOCATION)) {
		if (isNotEmpty(mapLink) || isNotEmpty(dealerInfo)) {
			return true;
		}
	}

	const requestedPhones = richContentToDisplay.filter((item) =>
		CONTENT_TYPES.CONTACT.includes(item)
	);
	if (requestedPhones.length > 0) {
		const hasAnyRequestedPhone = requestedPhones.some((phoneType) => {
			const deptName = phoneType.replace('phone-', '').toUpperCase();
			return isNotEmpty(phoneNumbers[deptName]);
		});
		if (hasAnyRequestedPhone) {
			return true;
		}
	}

	return false;
};

export default isEnoughAddData;
